define('views/components/distributor/distributor_list',['require','views/base/list_view','views/components/distributor/distributor','text!templates/components/distributor/distributor_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/distributor/distributor');

    var temp = require("text!templates/components/distributor/distributor_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

